import { CellProps } from 'react-table'

import { PlainHeader, StackedCell, StatusBadge, TableColumn } from '../../../../../../components'
import { EnderecoList } from '../../../../empresa/empresas-list/core/_models'
import { OrigemEndereco } from '../../core/_origem'
import { EnderecosActionsCell } from './EnderecosActionsCell'

// O endpoint de empresa serializa a UF como `UF` (getter `getUF()` da projeção do backend) e o de
// unidade como `uf`; lemos os dois para não depender da grafia.
const cidadeUf = (endereco: EnderecoList) =>
  [endereco.cidade, endereco.uf ?? endereco.UF].filter(Boolean).join('/')

export const enderecosColumns = (
  origem: OrigemEndereco,
  idOrigem: number
): ReadonlyArray<TableColumn<EnderecoList>> => [
  {
    Header: () => <PlainHeader>Nome / Tipo</PlainHeader>,
    id: 'nome',
    cellWidth: '220px',
    Cell: ({ row }: CellProps<EnderecoList>) => (
      <StackedCell primary={row.original.nome} secondary={row.original.tipoEndereco} />
    ),
  },
  {
    Header: () => <PlainHeader>Endereço / Bairro</PlainHeader>,
    id: 'descricao',
    Cell: ({ row }: CellProps<EnderecoList>) => (
      <StackedCell primary={row.original.descricao} secondary={row.original.bairro} />
    ),
  },
  {
    Header: () => <PlainHeader>Cidade/UF</PlainHeader>,
    id: 'cidade',
    cellWidth: '200px',
    hideOnMobile: true,
    Cell: ({ row }: CellProps<EnderecoList>) => (
      <StackedCell primary={cidadeUf(row.original) || undefined} />
    ),
  },
  {
    Header: () => <PlainHeader>CEP</PlainHeader>,
    id: 'cep',
    cellWidth: '120px',
    hideOnMobile: true,
    Cell: ({ row }: CellProps<EnderecoList>) => <StackedCell tabular primary={row.original.cep} />,
  },
  {
    Header: () => <PlainHeader>Status</PlainHeader>,
    id: 'ativo',
    cellWidth: '128px',
    // Endereço sem o campo veio de projeção antiga: é tratado como ativo.
    Cell: ({ row }: CellProps<EnderecoList>) => <StatusBadge active={row.original.ativo ?? true} />,
  },
  {
    Header: () => <PlainHeader>Ações</PlainHeader>,
    id: 'actions',
    cellWidth: '132px',
    align: 'end',
    Cell: ({ row }: CellProps<EnderecoList>) => (
      <EnderecosActionsCell origem={origem} idOrigem={idOrigem} endereco={row.original} />
    ),
  },
]
